var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { saveAlbumImagesAsync } from 'album/store/actions';
import { AlbumService } from 'album/store/service';
import { B64File } from 'common/classes/B64File.class';
import { Membre } from 'membre/classes/Membre.class';
import { dispatch } from 'store/store';
/**
 * Permet de gérer des photos pour les albums
 */
export class AlbumPhoto {
    /**
     * Constructeur de l'objet AlbumPhoto
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d, _e;
        if (row) {
            this.idAlbumPhoto = (_a = row.idAlbumPhoto) !== null && _a !== void 0 ? _a : null;
            this.idAlbum = (_b = row.idAlbum) !== null && _b !== void 0 ? _b : null;
            this.author = (_c = new Membre(row.author.infoPublic)) !== null && _c !== void 0 ? _c : null;
            this.file = row.file ? new B64File(row.file) : row.url ? new B64File(B64File.pathUrlToFile(row.url)) : null;
            this.actif = (_d = row.actif) !== null && _d !== void 0 ? _d : 0;
            this.saveDate = (_e = row.saveDate) !== null && _e !== void 0 ? _e : null;
        }
    }
    /**
     * Valide des photos dans un album
     * @param idAlbum Identifiant de l'album
     * @param idAlbumPhoto Liste des identifiants des photos à valider
     * @return Nombre de photos validées
     */
    static validateAlbumPhotos(idAlbum, idAlbumPhotos) {
        return __awaiter(this, void 0, void 0, function* () {
            return AlbumService.validateAlbumPhotos(idAlbum, idAlbumPhotos);
        });
    }
    /**
     * Supprime des photos dans un album
     * @param idAlbumPhoto Identifiant de l'AlbumPhoto
     * @return Nombre de photos supprimées
     */
    static deletePhotosFromAlbum(idAlbumPhotos) {
        return __awaiter(this, void 0, void 0, function* () {
            return AlbumService.deletePhotosFromAlbum(idAlbumPhotos);
        });
    }
    /**
     * Sauvegarder les photos relatives à un album
     * @param albumPhotos Photos de l'album
     */
    static save(albumPhotos) {
        dispatch(saveAlbumImagesAsync(albumPhotos));
    }
    /**
     * Utilisé pour renvoyer les informations au back
     */
    toRaw() {
        return {
            idAlbumPhoto: this.idAlbumPhoto,
            idAlbum: this.idAlbum,
            idAuthor: this.author.infoPublic.idMembre,
            file: this.file.toRaw(),
            actif: this.actif,
            saveDate: this.saveDate,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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